import type {
    BasketResponse,
    CartDigitalDataItem,
} from '../types/ocapi/basket';

/**
 * This utility function iterates through the digital cart items
 * from a SFCC BasketResponse and sums their quantities, to give
 * the total number of items in the cart.
 *
 * @param response an SFCC basket response
 * @returns total number of items in the digital cart
 */
export const getCartCount = (response: BasketResponse) => {
    const cartItems = response?.c_digitalData?.cart?.item;
    if (cartItems && cartItems.length > 0) {
        return cartItems.reduce(
            (acc: number, val: CartDigitalDataItem) => acc + val.quantity,
            0
        );
    }
    return undefined;
};
